export default "__VITE_ASSET__4b0824ae__"